const SPACING_UNIT = 8;

export default SPACING_UNIT;
